import { Model, Attr, HasOne } from 'spraypaint';
import { User, Organisation } from '@/api';
import i18n from '@/plugins/vue-i18n';
import ApplicationRecord from '../ApplicationRecord';

// Mirrors PROVIDER_ROW_PREFIX in dj-vital organisations/permissions.py.
export const PROVIDER_ROW_PREFIX = 'provider-';

export enum OrganisationUserRole {
  'Owner' = 'owner',
  'Manager' = 'manager',
  'User' = 'user',
}

@Model()
export default class OrganisationUser extends ApplicationRecord {
  static jsonapiType = 'organisation-users';

  static listHeaders() {
    return [
      {
        text: i18n.t('common.labels.email'),
        value: 'user.email',
      },
      {
        text: i18n.t('users.labels.role'),
        value: 'role',
      },
      {
        text: i18n.t('users.labels.fullName'),
        value: 'user.fullName',
      },
    ];
  }

  static scopeFactory() {
    return OrganisationUser.includes([]);
  }

  @Attr() role: OrganisationUserRole;

  @Attr() isDefault: boolean;

  // Synthesised server side for training sessions run by the user's provider.
  // Not a real record, so it cannot be saved or set as default.
  get isProviderManaged(): boolean {
    return String(this.id || '').startsWith(PROVIDER_ROW_PREFIX);
  }

  @Attr() status: string;

  @Attr() created: string;

  @Attr() changed: string;

  @Attr() firstName: string;

  @Attr() lastName: string;

  @Attr() email: string;

  @Attr() suppressMail: boolean;

  @HasOne() user: User;

  @HasOne() organisation: Organisation;

  get isOwner() {
    return this.role === OrganisationUserRole.Owner;
  }

  get isManager() {
    return this.role === OrganisationUserRole.Manager;
  }

  get isUser() {
    return this.role === OrganisationUserRole.User;
  }
}
